// extracted by mini-css-extract-plugin
export default {"details__topBarContainer":"AdminPackagesView_details__topBarContainer__gZ1Bi"};